// extracted by mini-css-extract-plugin
export default {"root":"ActiveFilterChips_root__Dn3Gz","chip":"ActiveFilterChips_chip__b7edN","chipClose":"ActiveFilterChips_chipClose__pwz1G","srOnly":"ActiveFilterChips_srOnly__9JQdF"};